import { isArray, isEmpty } from 'lodash';
export var applyLangTo = function (obj, iso) {
  if (typeof obj === 'object') {
    for (var key in obj) {
      var pattern = "_".concat(iso, "$");
      var re = new RegExp(pattern, 'i');
      if (key.match(re)) {
        var baseKey = key.replace(re, '');
        var langValue = obj[key];
        // console.log('key match', key, langValue);
        // console.log('base value', obj[baseKey]);
        // @ts-ignore
        if (langValue && !isArray(langValue) && typeof langValue === 'object' && langValue.hasOwnProperty('text')) {
          // this is a content node
          // @ts-ignore
          if (langValue.text) {
            obj[baseKey] = obj[key]; // don't recurse
          }
        } else {
          if (isArray(langValue)) {
            if (!isEmpty(langValue)) {
              obj[baseKey] = applyLangTo(obj[key], iso);
            } else {
              obj[key] = applyLangTo(obj[key], iso);
            }
          } else if (langValue !== null && langValue !== undefined) {
            obj[baseKey] = applyLangTo(obj[key], iso);
          }
        }
        // remove the lang version
        delete obj[key];
      } else {
        obj[key] = applyLangTo(obj[key], iso);
      }
    }
  }
  return obj;
};